import React from 'react';

// @material-ui/core components

// core components
import GridContainer from '@components/Grid/GridContainer.js';
import GridItem from '@components/Grid/GridItem.js';

import { Formik, FormikProps } from 'formik';
import { paymentPlanValidationSchema } from 'apps/things/app/validations';
import PaymentPlanForm from './ItemForm';
import CardWrapper from '@components/Card/CardWrapper';
import { PaymentPlanInput } from '../../assetAccount/constants';
interface IRTable {
  handleSubmit: (payload: PaymentPlanInput) => void;
  isLoading: boolean;
  item: PaymentPlanInput;
  inActive?: boolean;
}

const AddItem: React.FC<IRTable> = ({
  handleSubmit,
  isLoading,
  item,
  inActive
}) => {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CardWrapper>
          <Formik
            onSubmit={async (values: PaymentPlanInput) =>{ handleSubmit(values);}}
            initialValues={item}
            validationSchema={paymentPlanValidationSchema}
            validateOnChange={true}
          >
            {(formBag) => (
              <PaymentPlanForm
                formBag={
                  (formBag as unknown) as FormikProps<PaymentPlanInput>
                }
                disableLoginButton={isLoading}
                inActive={inActive}
              />
            )}
          </Formik>
        </CardWrapper>
      </GridItem>
    </GridContainer>
  );
};

export default AddItem;
